import React, { useRef, useState } from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { ExpectedMaterialSubmenuList } from '@modules/planner/work-order-menu/menu-items/expected-material';

export const useStyles = makeStyles((theme) => ({
  moreIcon: {
    color: theme.palette.grey[500],
    display: 'flex',
    fontSize: '16px',
  },
  bullet: {
    width: 12,
    height: 12,
    borderRadius: 12,
    marginRight: 8,
    marginLeft: 14,
    flexShrink: 0,
  },
}));

export const ExpectedMaterialBulkFormButton = ({
  handleOnItemClick,
  disabled,
}: {
  handleOnItemClick: (expectedMaterial: boolean) => void;
  disabled?: boolean;
}) => {
  const [open, setOpen] = useState(false);
  const anchor = useRef<HTMLDivElement>(null);

  return (
    <div>
      <Button
        onClick={() => setOpen(true)}
        color="primary"
        variant="contained"
        disabled={disabled}
        style={{ fontSize: '12px', padding: '4px 8px' }}
      >
        Zmeniť očakávaný materiál
      </Button>
      <div style={{ visibility: 'hidden' }} ref={anchor} />
      <Menu
        anchorEl={anchor.current}
        open={open}
        onClose={() => setOpen(false)}
      >
        <ExpectedMaterialSubmenuList handleOnItemClick={handleOnItemClick} />
      </Menu>
    </div>
  );
};
